// Build a Google Fonts css2 URL for one or more families
export const buildGoogleFontsHref = (families, weights = '400;700') =>
	'https://fonts.googleapis.com/css2?' +
	families.map(f => 'family=' + f.trim().replace(/\s+/g, '+') + ':wght@' + weights).join('&') +
	'&display=swap'
;

// Fire-and-forget: ensure a font's stylesheet is in the document.
// Use this in the EDITOR and the LIVE RENDER. Idempotent.
export const loadGoogleFont = (family) => {
	if (!family) return;
	const id = 'gf-' + family.trim().replace(/\s+/g, '-').toLowerCase();
	if (document.getElementById(id)) return;
	const link = document.createElement('link');
	link.id = id;
	link.rel = 'stylesheet';
	link.href = buildGoogleFontsHref([family]);
	document.head.appendChild(link);
};

// Load + verify a family actually resolves on Google Fonts. Resolves true/false.
export const tryLoadGoogleFont = (family) => new Promise((resolve) => {
	if (!family || !family.trim()) { resolve(false); return; }
	const fam = family.trim();
	const id = 'gf-' + fam.replace(/\s+/g, '-').toLowerCase();
	const finish = async () => {
		try {
			await document.fonts.load(`16px "${fam}"`);
			resolve(document.fonts.check(`16px "${fam}"`));
		} catch { resolve(false); }
	};
	let link = document.getElementById(id);
	if (link) { finish(); return; }
	link = document.createElement('link');
	link.id = id;
	link.rel = 'stylesheet';
	link.href = buildGoogleFontsHref([fam]);
	link.onload = finish;
	link.onerror = () => { link.remove(); resolve(false); };
	document.head.appendChild(link);
});

export const CUSTOM_FONT_FAMILY = 'custom';

// Ensure a campaign font's assets are present in the document
export const loadCampaignFont = async (font) => {
	if(!font) return;
	const source = font.source || 'system';

	if(source === 'google'){
		loadGoogleFont(font.family);
		return;
	}

	if(source === 'custom'){
		if(typeof window === 'undefined' || !window.FontFace) return;
		const files = (font.custom && font.custom.files) || [];
		await Promise.all(files.map(async (f) => {
			if(!f || !f.url) return;
			// Skip if an identical face is already registered (re-renders, HMR).
			const already = Array.from(document.fonts).some(face =>
				face.family === CUSTOM_FONT_FAMILY &&
				face.weight === f.fontWeight &&
				face.style === f.fontStyle);
			if(already) return;
			try {
				const face = new FontFace(CUSTOM_FONT_FAMILY, `url(${f.url})`, {
					weight: f.fontWeight,
					style: f.fontStyle,
				});
				document.fonts.add(face);
				await face.load();
			} catch (e) {
				// CORS or bad URL: this style falls back to default on the page.
			}
		}));
		return;
	}
};
